import { NextRouter } from "next/router";

import { LoginFormFieldsTypes } from "../../common/contant";
import { LoginFormAuthResult } from "../loginFormAuth.types";
import { applyRegistrationSuccessSideEffects, LoginEventTracker, trackCompanyRegistration } from "./loginAuthAnalytics";

interface RegistrationFailureParams {
    router: NextRouter;
    setReferralCode?: (code: undefined) => void;
    setShouldPreventLayoutSwitch?: (value: boolean) => void;
}

export function handleRegistrationFailure({
    router,
    setReferralCode,
    setShouldPreventLayoutSwitch
}: RegistrationFailureParams) {
    setShouldPreventLayoutSwitch?.(false);
    delete router.query["referral_code"];
    router.replace({ ...router, hash: undefined }, undefined, { shallow: true });
    setReferralCode?.(undefined);
}

interface ProcessNewUserRegistrationParams {
    values: LoginFormFieldsTypes;
    result: LoginFormAuthResult;
    handleEventTracking: LoginEventTracker;
    router: NextRouter;
    setCookie: (name: string, value: string, options: object) => void;
    setReferralCode?: (code: undefined) => void;
    setShouldPreventLayoutSwitch?: (value: boolean) => void;
    onSuccess: (values: LoginFormFieldsTypes, result: LoginFormAuthResult) => void | Promise<void>;
}

/** Tracks registration, applies side effects, and delegates post-registration routing to the caller. */
export async function processNewUserRegistration({
    values,
    result,
    handleEventTracking,
    router,
    setCookie,
    setReferralCode,
    setShouldPreventLayoutSwitch,
    onSuccess
}: ProcessNewUserRegistrationParams): Promise<boolean> {
    trackCompanyRegistration(handleEventTracking, values, result);

    if (!result?.status) {
        handleRegistrationFailure({ router, setReferralCode, setShouldPreventLayoutSwitch });
        return false;
    }

    applyRegistrationSuccessSideEffects({ values, setCookie });
    await onSuccess(values, result);
    return true;
}
